import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { claimAngelPage } from "@/services/api/VentureCapital";
import { useState } from "react";
import { toast } from "react-hot-toast";
import Spinner from "../Spinner";

export const ClaimAngel = ({
  user,
  investor,
  getVCClaimUserData,
  setOpenClaimVCPopup,
  openClaimVCPopup,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {

    setLoading(true);
    try {
      const response = await claimAngelPage({
        vc_id: investor.id,
        user_id: user.id,
        name: investor.name,
      });
      
      setLoading(false);
      setOpenClaimVCPopup(null);
      toast.success("You have successfully claimed this angel investor profile.");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      setLoading(false);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <Dialog open={openClaimVCPopup} onOpenChange={setOpenClaimVCPopup}>
      <DialogContent className="bg-white text-background">
        <DialogHeader>
          <DialogTitle>Claim Angel Investor Profile</DialogTitle>
          <DialogDescription>
            Are you sure you want to claim this angel investor profile? This will allow you to manage and edit the profile information.
          </DialogDescription>
        </DialogHeader>

        <div className="p-4 my-4 space-y-3 border rounded-lg border-background/10">
          <div className="flex justify-between">
            <span className="text-sm text-background/60">Angel Investor:</span>
            <span className="font-medium">{investor.name}</span>
          </div>
          {investor.website && (
            <div className="flex justify-between">
              <span className="text-sm text-background/60">Website:</span>
              <span className="font-medium">{investor.website}</span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-sm text-background/60">Your Email:</span>
            <span className="font-medium">{user.email}</span>
          </div>
        </div>

        <div className="flex justify-end gap-x-2">
          <Button
            variant="outline"
            onClick={() => setOpenClaimVCPopup(null)}
            className="bg-white border-background/20 hover:bg-background/10"
          >
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={handleSubmit}
            disabled={loading}
            className="bg-background text-white hover:bg-background/80"
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <Spinner className="w-4 h-4" /> Claiming...
              </div>
            ) : (
              "Confirm Claim"
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
